import { createStyles } from "@mantine/emotion";

export const useStylesInfoBanner = createStyles(
  (theme, { colorAlertBg = theme.infoBanner.info.bg } = {}) => ({
    banner: {
      width: "100%",
      paddingLeft: "0",
      paddingRight: "0",
      paddingTop: theme.spacing.infoBanner.padding,
      paddingBottom: theme.spacing.infoBanner.padding,
      position: "static",
      borderRadius: "0",
      "&:before": {
        position: "absolute",
        content: "''",
        backgroundColor: colorAlertBg,
        left: "calc(-200% + 1em)",
        width: "200%",
        height: "100%",
        top: "0",
      },
      "&:after": {
        position: "absolute",
        content: "''",
        backgroundColor: colorAlertBg,
        right: "calc(-200% + 1em)",
        width: "200%",
        height: "100%",
        top: "0",
        zIndex: "99999",
      },
      ".mantine-Alert-wrapper": {
        alignItems: "center",
      },
      ".mantine-Alert-body": {
        gap: "0",
      },
    },
    bannerBox: {
      overflow: "hidden",
    },
  }),
);
